;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.9";import * as Sentry from '@sentry/nextjs';

import { getClientInitOptions } from '@catawiki/observability/client';
import { getRuntimeConfig } from '@catawiki/next-config/runtime-config';

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const release = process.env.NEXT_PUBLIC_SENTRY_RELEASE;

const runtimeConfig = getRuntimeConfig() || {};
const environment =
  runtimeConfig.stage ||
  runtimeConfig.environment ||
  process.env.NEXT_PUBLIC_APP_ENV ||
  'staging';

if (!dsn || !release) {
  console.warn(
    '[Sentry] Skipping client initialization because NEXT_PUBLIC_SENTRY_DSN or NEXT_PUBLIC_SENTRY_RELEASE is missing'
  );
} else {
  Sentry.init({
    ...getClientInitOptions({
      dsn,
      environment,
      release,
      sampleRate: {
        production: 0.1,
        staging: 1,
        development: 0,
      },
      tracesSampleRate: {
        production: 0.1,
        staging: 1,
        development: 0,
      },
    }),
    ignoreErrors: [
      // Suppress bidder app reporting because of translation insertion in DOM (errors #418, #423, #425)
      /error #(418|423|425)/,
    ],
  });

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).Sentry = Sentry;
  }
}
